import React from 'react';
import SharedModelListItem from './SharedModelListItem.jsx';

const ModelShared = ({ user, shared, sharedUsers, sharedOrganizations }) => {
    const markedOrganizations = user.organizations.filter((org) => sharedOrganizations.includes(org.id));

    const renderOrganizationsOrPrivate = () => {
        if (!shared) {
            return (
                <span key='private' className='inline-block'>
                    <SharedModelListItem text='Private' isMarked={true} disabled={true} readOnly={true} />
                </span>
            );
        } else {
            const items = [];
            markedOrganizations.forEach((org, index) => {
                items.push(
                    <span key={org.id} className='inline-block'>
                        <SharedModelListItem
                            index={index}
                            text={org.name}
                            isMarked={true}
                            disabled={true}
                            readOnly={true}
                        />
                    </span>
                );
                if (index < markedOrganizations.length - 1) {
                    items.push(
                        <span key={`comma-org-${index}`} className='inline-block mr-1'>
                            ,{' '}
                        </span>
                    );
                }
            });
            return items;
        }
    };

    return (
        <div>
            <div className='flex flex-wrap'>{renderOrganizationsOrPrivate()}</div>

            {sharedUsers && sharedUsers.length > 0 && (
                <div>
                    <p className={'text-theme1-text2 mt-4 mb-1'}>Shared with:</p>
                    <div className='flex items-center flex-wrap'>
                        {sharedUsers.map(({ id, name }, index) => {
                            return (
                                <div
                                    key={id}
                                    className='min-w-46 flex items-center justify-center space-x-4 flex-row rounded-4xl border border-theme1-text3 px-4 py-2 mr-2 mb-2'
                                >
                                    <div className={`text-theme1-primary2`}>{name}</div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ModelShared;
